import promise from 'promise';

import api from 'app/shared/utils/api';

import ErrorRMW from 'app/shared/model/ErrorRMW';

// service
import appLogger from 'app/shared/loggers/appLogger';

const getAccessRestrictedErrorMessage = (email, applicationsOwnerEmail) => {
    const message = `You are signed in as ${email}.
        This information is only available to ${applicationsOwnerEmail}.
        To see this information, you need to switch accounts.`;

    return message;
};

const ApplicationActions = {
    enableApplications() {
        return dispatch => dispatch(api.users.applications.enableApplications())
            .then((response = {}) => {
                if (response.success === false) {
                    return promise.reject(response.error);
                }
                return response;
            }).catch(err => promise.reject(err));
    },
    inviteToApply(body = {}) {
        return dispatch => dispatch(api.users.applications.inviteToApply(body))
            .then((response = {}) => {
                if (response.success === false) {
                    return promise.reject(response.error);
                }
                return response;
            }).catch((errorRMWModel) => {
                appLogger.logError({
                    message: errorRMWModel.message,
                    context: 'ApplicationActions.inviteToApply',
                });

                return promise.reject(errorRMWModel);
            });
    },
    getSummary(listingAlias = '') {
        const params = {
            listingAlias,
        };

        return (dispatch, getState) => dispatch(api.users.applications.getSummary(params))
            .then((response = {}) => {
                const { success, error, response: data } = response;

                if (success === false) {
                    return promise.reject(error);
                }

                const { applicationsOwnerEmail, isApplicationsAccessRestricted } = data;

                const { email } = getState().user;

                if (isApplicationsAccessRestricted) {
                    const message = getAccessRestrictedErrorMessage(email, applicationsOwnerEmail);

                    const errorRMWModel = ErrorRMW({
                        code: 'isApplicationsAccessRestricted',
                        message,
                        data,
                    });

                    return promise.reject(errorRMWModel);
                }

                return response;
            }).catch((errorRMWModel) => {
                const contextBase = 'ApplicationActions.getSummary';
                const context = errorRMWModel.code
                    ? contextBase.concat(` - ${errorRMWModel.code}`)
                    : contextBase;

                appLogger.logError({
                    message: errorRMWModel.message,
                    context,
                });

                return promise.reject(errorRMWModel);
            });
    },
};

export default ApplicationActions;
